var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.05 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b143ff;}.cls-2{fill:#ffec00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.05 0 6.45 0 0 7.86 0 30 45.6 30 52.05 22.14 52.05 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.88 10.26 38.02 13.93 43.79 13.93 44.65 10.26 38.88 10.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.97 18.58 42.74 18.58 43.61 14.91 37.84 14.91 36.97 18.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.13,14.27l.94-4H24.55L21.17,24.61l-2.83-3.49h.38l2.39-2.24,2-8.62H8.83L5.34,25.13h5.19l1.16-4.9,4,4.92H21.6v0h12l1-4H27.19l.34-1.42h7.32l.95-4H28.47l.33-1.42ZM12.42,17.11l.67-2.84H17l-.94,4-1-1.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.06 5.33 8.41 2.53 46.71 2.53 44.37 5.33 6.06 5.33"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.975cb7648770ec225c79687fa8eb3acd.svg";
export { ForwardRef as ReactComponent };